/* eslint-disable no-return-await */
import cc from "../utils/common";

/**
 * @description 风控请求带图形验证
 * @param {*} data - 请求入参
 * @param {*} successCB - 成功回调
 * @param {*} errorCb - 失败回调
 * @param {*} closeCb - 短信验证码关闭弹窗回调
 * @param {*} fail  - 关闭图形验证
 */
export let basePassport = (data, successCB, errorCb, closeCb, fail) => {
  try {
    let _data = {
      // 领券借口
      url: data.url,
      activityCode: data.activityCode,
      riskType: data.riskType,
      error_code: data.error_code || "",
      dataParams: data.params || data.data,
      cb: function(res) {
        // 风控过了以后
        cc.removeLoading();
        successCB(res);
      },

      fail: function(res) {
        fail && fail(res);
      },
      errorCb: function(res) {
        cc.removeLoading();
        if (errorCb) errorCb(res);
      },
      closeCb: function() {
        if (closeCb) closeCb();
      }
    };
    if (window.passport) {
      passport.init(_data);
    }
  } catch (error) {
    console.log(error);
  }
};

//获取活动Code

let activityCode = () => {
  let activityCode = cc.getQueryString("activityCode");
  return activityCode;
};

// //LDP抽奖首页
// export let main = async () => {
//   let params = {
//     url: cc.config.actDomain + "/act-wap-web/drawaward/gateway/main.do",
//     data: {
//       activityCode: activityCode()
//     }
//   };
//   return await cc.requestPromise(params);
// };

// //抽奖
// export let draw = async (successCB, errorCb, closeCb, fail) => {
//   let params = {
//     url: cc.config.actDomain + "/act-wap-web/drawaward/gateway/draw.do",
//     riskType: cc.os.isApp ? "client" : "H5",
//     error_code: "",
//     data: {
//       activityCode: activityCode(),
//       sceneCode: "",
//       channel: cc.os.isApp ? "MOBILE" : "WAP"
//     }
//   };
//   basePassport(params, successCB, errorCb, closeCb, fail);
// };

//LDP抽奖首页
export let main = async () => {
  let params = {
    url:
      cc.config.GAME_API +
      "/sngame-web/gateway/platform/lotteryDraw/getDrawHome.do",
    data: {
      activityCode: activityCode()
    }
  };
  return await cc.requestPromise(params);
};

//抽奖
export let draw = async (successCB, errorCb, closeCb, fail) => {
  let params = {
    url:
      cc.config.GAME_API +
      "/sngame-web/gateway/platform/lotteryDraw/drawAction.do",
    riskType: cc.os.isApp ? "client" : "H5",
    error_code: "",
    data: {
      activityCode: activityCode(),
      sceneCode: "",
      channel: cc.os.isApp ? "MOBILE" : "WAP"
    }
  };
  basePassport(params, successCB, errorCb, closeCb, fail);
};

/**
 * 中奖记录
 */
export let queryPrizeRecord = async () => {
  let params = {
    url:
      cc.config.GAME_API +
      "/sngame-web/api/gateway/prizeRecord/queryPrizeRecord.do",
    data: {
      code: activityCode(),
      operationAngle: "3" // 操作维度 1：活动 2：聚合页 3：父子活动
    }
  };
  return await cc.requestPromise(params);
};

/**
 * 任务列表
 */
export let queryTask = async () => {
  let params = {
    // url: cc.config.GAME_API + "/sngame-web/api/gateway/draw/queryTask.do",
    url:
      cc.config.GAME_API +
      "/sngame-web/api/gateway/task/templateOne/queryTask.do",
    data: {
      activityCode: activityCode()
    }
  };
  return await cc.requestPromise(params);
};

/**
 * 分享换次数
 */
export let addQuaByShare = async () => {
  let params = {
    url: cc.config.GAME_API + "/sngame-web/api/gateway/draw/addQuaByShare.do",
    data: {
      activityCode: activityCode(),
      addExtraQuaNum: 1
    }
  };
  return await cc.requestPromise(params);
};

/**
 * 任务奖励发奖领取抽奖次数接口
 */
export let sendTaskPrize = async subActivityId => {
  let params = {
    url:
      cc.config.GAME_API +
      "/sngame-web/api/gateway/task/templateOne/sendTaskPrize.do",
    data: {
      activityCode: activityCode(),
      sendPrizeActivityId: subActivityId
    }
  };
  return await cc.requestPromise(params);
};

/**
 * 通用口令/小程序token分享接口
 * @param {*} activityCode
 */
export let getShareContent = async () => {
  let params = {
    url:
      cc.config.GAME_API + "/sngame-web/share/api/gateway/getShareContent.do",
    data: {
      activityCode: activityCode()
    }
  };
  return await cc.requestPromise(params);
};

/**
 * 兑换通用接口
 * @param {*} exchangeId
 * @param {*} activityCode
 */
export let exchangeExcute = async exchangeId => {
  let params = {
    url:
      cc.config.GAME_API + "/sngame-web/api/gateway/exchange/exchangeExcute.do",
    data: {
      activityCode: activityCode(),
      exchangeId: exchangeId
    }
  };
  return await cc.requestPromise(params);
};

/**
 * 游戏平台配置
 */
export let gameapi = async (activityCode, gameId) => {
  let params = {
    // url: "//gameapi.suning.com/sngame-web/api/configjson/queryByModuleId.do",  // 生产
    url: cc.config.GAME_API + "/sngame-web/api/configjson/queryByModuleId.do", // 新港
    data: {
      // gameId: "GM0061", // 生产
      // gameId: "GM0130", // 新港
      gameId: gameId,
      moduleId: "template",
      activityCode: activityCode
    }
  };
  return await cc.requestPromise(params);
};
